import { FIELD_TYPES } from "constants/template-field-type";
import imagesGridFieldsConfig from "segments/desktop/core-components/images-grid/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Only Image",
    fields: imagesGridFieldsConfig
};
